import React from 'react';
import Component from '../../dispatcher/modules/component/Component';
import RouterUtil from './RouterUtil';
import { Switch } from 'react-router-dom';
import { AuthService } from '../../dispatcher/authentication';
import { ROUTER_PROPS } from './Types';
// @ts-ignore
import Properties from 'properties';

class Router extends Component<ROUTER_PROPS, {}> {
  constructor(props: ROUTER_PROPS) {
    super(props);
    RouterUtil.addRoutes(props.config);
  }

  render() {
    const { IS_NOT_LOGIN_APP } = Properties;
    const { config = [], children = [], defaultRoute } = this.props;
    let isAuthenticated = AuthService.isAuthenticatedAsync();
    if (!isAuthenticated && !IS_NOT_LOGIN_APP) return null;

    return (
      <Switch>
        {/* Redirect from view/ navigation */}
        {RouterUtil.redirectRoute('/view/', true, defaultRoute)}

        {RouterUtil.renderChildren(children)} {/* render all the children */}
        {RouterUtil.renderRoutes(config)} {/* render all protected routes */}

        {/* Redirect from view/* navigation, any route from view/* that is not rendered */}
        {RouterUtil.redirectRoute('/view/*', true, defaultRoute)}

        {/* Redirect from /* navigation, any route from /* that is not rendered */}
        {RouterUtil.redirectRoute('/*', true, defaultRoute)}
      </Switch>
    );
  }
}

export default Router;
